export enum ViewExportType {
  Standard = "standard",
  Expanded = "expanded",
  Itemized = "itemized",
}
